import { render, staticRenderFns } from "./ManutSenhaComprasPrazo.vue?vue&type=template&id=58edc884&"
import script from "./ManutSenhaComprasPrazo.vue?vue&type=script&lang=js&"
export * from "./ManutSenhaComprasPrazo.vue?vue&type=script&lang=js&"
import style0 from "./ManutSenhaComprasPrazo.vue?vue&type=style&index=0&id=58edc884&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports